@if (form) {
  <form class="action-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
    <span class="title">{{ titleKey | translate }}</span>
    <app-information-block [text]="descriptionKey | translate"></app-information-block>

    @if (isReopen) {
      <section class="astral-section-surface astral-section-surface--compact astral-form-stack">
        <astral-input [control]="form.controls['periodDate']"></astral-input>
        <astral-textarea [control]="form.controls['reason']"></astral-textarea>
        <astral-checkbox [control]="form.controls['confirmed']"></astral-checkbox>
      </section>

      @if (reopenInfo?.manualOpeningBalancesToInvalidate > 0) {
        <app-information-block
          status="warning"
          [text]="
            'ACCOUNTING_PERIOD.REOPEN_MANUAL_OPENING_BALANCES_WILL_BE_DELETED'
              | translate: { count: reopenInfo.manualOpeningBalancesToInvalidate }
          "
        ></app-information-block>
      }
      @if (reopenInfo?.remainingClosedToDate?.hasValue()) {
        <app-information-block
          [text]="
            'ACCOUNTING_PERIOD.REOPEN_REMAINING_CLOSED_INFO'
              | translate: { date: reopenInfo.remainingClosedToDate.toLocaleDateString() }
          "
        ></app-information-block>
      }
      @if (reopenInfo && !reopenInfo.canReopen) {
        <app-information-block [text]="'ACCOUNTING_PERIOD.REOPEN_NOT_AVAILABLE' | translate"></app-information-block>
      }
      @if (reopenInfoLoadFailed) {
        <app-information-block [text]="'ACCOUNTING_PERIOD.REOPEN_INFO_LOAD_FAILED' | translate"></app-information-block>
      }
    } @else {
      @if (currentAccountingClosedTo) {
        <app-information-block
          [text]="currentAccountingClosedToKey | translate: { period: currentAccountingClosedToText }"
        ></app-information-block>
      }
      <section class="astral-section-surface astral-section-surface--compact astral-form-stack">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['year']" type="number" inputMode="numeric"></astral-input>
          <astral-select [control]="form.controls['month']" [itemsSource]="selectableMonths"></astral-select>
        </astral-layout-group>
        <astral-textarea [control]="form.controls['description']"></astral-textarea>
      </section>
      @if (alreadyClosedCompanies.length > 0) {
        <div class="astral-stack-s">
          <app-information-block [text]="'ACCOUNTING_PERIOD.ALREADY_CLOSED_COMPANIES_INFO' | translate"></app-information-block>
          <ul>
            @for (company of alreadyClosedCompanies; track company.id) {
              <li>
                {{ company.toString() }} - {{ 'ACCOUNTING_PERIOD.CLOSED_TO_DATE' | translate }}:
                {{ company.accountingClosedTo.toLocaleDateString() }}
              </li>
            }
          </ul>
        </div>
      }
      @if (isSelectedPeriodAlreadyClosed) {
        <app-information-block
          status="error"
          [text]="'ACCOUNTING_PERIOD.ALREADY_CLOSED_SELECTION_ERROR' | translate"
        ></app-information-block>
      }
      @if (isSelectedPeriodCurrentOrFuture) {
        <app-information-block
          status="warning"
          [text]="'ACCOUNTING_PERIOD.CURRENT_OR_FUTURE_WARNING' | translate"
        ></app-information-block>
      }
    }

    <div class="astral-form-actions">
      <astral-button variant="primary" type="submit" labelKey="OK_BTN" [disabled]="!canSubmit()"></astral-button>
      <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" [disabled]="working" (click)="cancel()"></astral-button>
    </div>
  </form>
}
